<template>
  <QuestionBase :id="db.saveField"

                :errors="[...jsErrors]"
                :question="question"
                :valid="!!data.length">
    <div class="accordion sub-items">
      <!-- Selected People -->
      <transition-group name="fade">
        <ObjectCard v-for="(person, index) in data"
                    :id="'trusteeSecondaryData' + index"
                    :key="'trusteeSecondaryData' + person.id"
                    :ref="'trusteeSecondaryData' + index"
                    :select-mode="true"
                    :selected="true"
                    :show-delete="false"
                    :title="cardTitle(person)"
                    :value="data[index]"
                    type="trusteeSecondaryData"
                    :loading="loading"
                    @click="deselectConfirm(person, 'Remove person from your secondary Trustees?')"
                    @delete="deletePerson(person.id)"
                    @save="savePerson( null, 'trusteeSecondaryData'+index)">

          <PersonWill v-if="person.type === 'person'"
                      :key="'trusteeSecondary-form-data' + person.id"
                      v-model="data[index]"
                      :errors-post="errorsPatch"
                      :no-save="true"
                      :objectId="person.id"
                      @save="savePersonForm($event, person)"/>

        </ObjectCard>
      </transition-group>
    </div>
    <!-- New People -->
    <transition name="fade">
      <b-button class="btn-question w-100"
                @click="show.addPerson=true">
        <i class="i-Add text-25 font-weight-800 mr-2"> </i> Add Trustee
      </b-button>
    </transition>

    <WillPeopleModal
        v-model="show.addPerson"
        title="Add Secondary Trustees"
        :dataSelected="data"
        :options="optionsData"
        :show-charities="false"
        :sub-title="'Select your trustees by selecting existing people or adding new people. You can select multiple individuals for this role.'"
        :hide-type-options="true"
        :show-groups="false"
        :add-person-function="addPersonFunction"
        @dataSelectedUpdate="data=$event"
        @save="save"/>

  </QuestionBase>
</template>

<script>
import {personHelpers} from "@/mixins/personHelpers";
import {peopleSaveHelpers} from "../../objects/peopleSaveHelpers";
import {questionLoadHelpers} from "../../../helpers/questionLoadHelpers";
import {saveHelpers} from "@/views/questionnaires/saveHelpers";
import {willPeopleObjectHelpers} from "../helpers/willPeopleObjectHelpers";

import QuestionBase from "../../../QuestionBase";
import ObjectCard from "../../objects/ObjectCard";
import PersonWill from "../../../../fieldsets/sub/people/PersonWill";
import WillPeopleModal from "../helpers/WillPeopleModal";

export default {
  name: 'SecondaryTrustees',
  components: {
    WillPeopleModal,
    PersonWill,
    ObjectCard,
    QuestionBase
  },
  mixins: [
    peopleSaveHelpers,
    personHelpers,
    questionLoadHelpers,
    saveHelpers,
    willPeopleObjectHelpers,
  ],
  props: {
    value: {
      type: Array,
      required: false
    },
    details: {
      type: Object,
      required: true
    },
    optionsData: {
      type: Array,
      required: true
    },
    addPersonFunction: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      question: {
        title: 'Secondary Trustees',
        subTitle: 'Please confirm who you would like to act as the secondary trustees. To deselect a person, simply click on their name.',
        tip: null
      },
      db: {
        saveLocation: 'product_will_data',
        saveField: 'secondaryTrustees',
        formPath: 'data.trustees.details.secondary',
        jsonSaveField: 'secondary'
      },
      args: {
        skippable: false,
        required: true,
        customErrorMessage: 'You must have more than one Secondary Trustee, click to select'
      },
      serverErrors: [],
      errorsPatch: {},
      jsErrors: [],
      skipped: false,
      show: {
        addPerson: false
      }
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    }
  }
}
</script>
